import { Component, HostBinding, Input } from '@angular/core';
import { DocumentHostComponent } from '@components/element-widgets/document-host/document-host.component';
import { ElementErrorDirective } from '@components/element-widgets/element-error/element-error.directive';
import { ElementCountWatcherDirective } from 'src/app/element-handling/element-count-watcher.directive';
import { FondsportraitBlueprintComponent } from 'src/openapi-client';
import { FundsportraitTypeMapperComponent } from '../fundsportrait-type-mapper/fundsportrait-type-mapper.component';

@Component({
  selector: 'wct-blueprint-component',
  standalone: true,
  imports: [
    DocumentHostComponent,
    FundsportraitTypeMapperComponent,
    ElementCountWatcherDirective,
    ElementErrorDirective,
  ],
  templateUrl: './blueprint-component.component.html',
  styleUrl: './blueprint-component.component.scss',
})
export class BlueprintComponentComponent {
  @Input({ required: true }) public component!: FondsportraitBlueprintComponent;

  @Input({ required: false }) public set border(border: boolean) {
    this._border = border ? true : null;
  }

  @HostBinding('attr.border') protected _border: true | null = null;
}
